import { PageType } from '@witkac/kartamiejska-shared';

import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'page',
  type: 'object',
  properties: {
    mainImage: {
      title: 'Obrazek tła',
      type: 'number',
      fieldRequired: false
    },
    images: {
      title: 'Pozostałe obrazki',
      type: 'string',
      fieldRequired: false
    },
    name: {
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    slug: {
      type: 'string',
      fieldRequired: false,
      maxLength: 500,
      pattern: '^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$',
      validationMessages: {
        pattern: 'Slug nie może zawierać znaków specjalnych oraz polskich liter.'
      }
    },
    priority: {
      type: 'number',
      fieldRequired: true
    },
    state: {
      fieldRequired: true,
      type: 'string'
    },
    type: {
      type: 'string',
      fieldRequired: true
    },
    content: {
      type: 'string',
      title: 'Zawartość strony'
    },
    slots: {
      type: 'array',
      default: [],
      fieldRequired: false,
      items: {
        type: 'string'
      }
    },
    data: {
      fieldRequired: `this.type === "${PageType.URL}" || this.type === "${PageType.MailTemplate}"`
    },
    media: {
      type: 'array',
      fieldRequired: false,
      items: {
        type: 'number'
      }
    }
  }
};
